import React, {useState} from 'react';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import HelpTree from './helpTree/HelpTree'
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import HelpOptions from './helpOptions/HelpOptions'


export const HELP_TREE = "HELP_TREE";
export const HELP_GRADING = "HELP_GRADING";
export const HELP_OPTIONS = "HELP_OPTIONS";

const LargeTollip = withStyles((theme) => ({
  tooltip: {
    fontSize: 15,
  },
}))(Tooltip);

export default function HelpButton(props){
  const [seeHelp, setSeeHelp] = useState(false);

  return (
    <span>
      <LargeTollip title="Press To See Help" enterDelay={500} leaveDelay={100}>
        <IconButton size="small" style={{padding:"4px", fontSize:"20px"}} onClick={()=> setSeeHelp(true)}>
          <i style={{color:"#518b8c"}} class="fas fa-question-circle"></i>
        </IconButton>
      </LargeTollip>
      {
        props.type === HELP_TREE &&
          <HelpTree open={seeHelp} handleClose={()=>setSeeHelp(false)}/>
      }
      {
        props.type === HELP_GRADING &&
          <HelpTree open={seeHelp} handleClose={()=>setSeeHelp(false)}/>
      }
      {
        props.type === HELP_OPTIONS  &&
          <HelpOptions open={seeHelp} handleClose={()=>setSeeHelp(false)}/>
      }
    </span>
  )
}
